import React from 'react';
import { Grid } from '@material-ui/core';
import { Link } from '../../index';
import { ArrowLeft } from '../../icon/solid';
import { getResourceNameFromPath, getListRouteByDetailPageRoute } from '../../../utility/path';
import { capitalizeAll } from '../../../utility/string';
import useStyles from './styles';

const BackToList = () => {
  const classes = useStyles();

  const resourceRoute = getListRouteByDetailPageRoute();
  const resourceName = `Back to ${capitalizeAll(getResourceNameFromPath())}s`;

  return (
    <Grid container>
      <Link to={resourceRoute} className={classes.backToLis}>
        <span className={classes.iconWrapper}><ArrowLeft className={classes.icon} /></span>
        { resourceName }
      </Link>
    </Grid>
  );
};

export default BackToList;
